import React from 'react';
import ParallaxSection from './ParallaxSection';

const events = [
  {
    id: 1,
    name: 'Wöchentliches Vereinstreffen für Mitglieder',
    date: 'Jeden Mittwoch',
    description: 'Wöchentliches Treffen für Vereinsmitglieder.',
    location: 'Flugplatz Bad Langensalza (EDEB)',
  },
];

const Events: React.FC = () => {
  return (
    <ParallaxSection
      id="veranstaltungen"
      backgroundImage="/images/Flugsportverein_Bilder_8.jpg"
    >
      <div>
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Veranstaltungen</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Unsere Events
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto mb-10">
            Besuchen Sie unsere Veranstaltungen und werden Sie Teil unserer Community!
          </p>
        </div>

        <div className="space-y-6">
          {events.map((event) => (
            <div 
              key={event.id} 
              className="bg-white shadow overflow-hidden rounded-lg hover:shadow-md transition-shadow duration-300"
            >
              <div className="px-4 py-5 sm:px-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">{event.name}</h3>
                  <p className="text-sm font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded">
                    {event.date}
                  </p>
                </div>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">{event.location}</p>
              </div>
              <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
                <p className="text-sm text-gray-500">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Events; 